import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-youtube',
  templateUrl: './youtube.component.html',
  styleUrls: ['./youtube.component.scss']
})
export class YoutubeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
